import { d as isSameGroup } from '../../chunks/bundle-FKPPxTH5.js';
import '../../chunks/bundle-FpyOg33P.js';
import '../../chunks/bundle-beh08z4N.js';
import '../../chunks/bundle-oJDE4gxT.js';
import '../../chunks/bundle-HBHAJNcI.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-nfdZFsK-.js';
import '@sendbird/chat/message';

/**
 * exported, should be backward compatible
 */
var compareMessagesForGrouping = function (prevMessage, currMessage, nextMessage, currentChannel, replyType) {
    if (replyType === 'THREAD' && (currMessage === null || currMessage === void 0 ? void 0 : currMessage.threadInfo)) {
        return [false, false];
    }
    var sendingStatus = (currMessage === null || currMessage === void 0 ? void 0 : currMessage.sendingStatus) || '';
    var isAcceptable = sendingStatus !== 'pending' && sendingStatus !== 'failed';
    return [
        isSameGroup(prevMessage, currMessage, currentChannel) && isAcceptable,
        isSameGroup(currMessage, nextMessage, currentChannel) && isAcceptable,
    ];
};

export { compareMessagesForGrouping };
//# sourceMappingURL=compareMessagesForGrouping.js.map
